module.exports = __webpack_public_path__ + "img/icon-course-005.c4c1c864.png";